import React, { cloneElement, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { withStyles } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import {
  AppBar,
  useRecordContext,
  useResourceContext,
  Filter,
} from "react-admin";
// import BackButton from './backButton'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  TopToolbar,
  RefreshButton,
  TextInput,
  DateTimeInput,
  AutocompleteInput,
  UrlField,
} from "react-admin";
import { useLocation } from "react-router-dom";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";

const regions = [
  { id: "Abra", name: "Abra" },
  { id: "Agusan del Norte", name: "Agusan del Norte" },
  { id: "Agusan del Sur", name: "Agusan del Sur" },
  { id: "Aklan", name: "Aklan" },
  { id: "Albay", name: "Albay" },
  { id: "Antique", name: "Antique" },
  { id: "Apayao", name: "Apayao" },
  { id: "Aurora", name: "Aurora" },
  { id: "Basilan", name: "Basilan" },
  { id: "Bataan", name: "Bataan" },
  { id: "Batanes", name: "Batanes" },
  { id: "Batangas", name: "Batangas" },
  { id: "Benguet", name: "Benguet" },
  { id: "Biliran", name: "Biliran" },
  { id: "Bohol", name: "Bohol" },
  { id: "Bukidnon", name: "Bukidnon" },
  { id: "Bulacan", name: "Bulacan" },
  { id: "Cagayan", name: "Cagayan" },
  { id: "Camarines Norte", name: "Camarines Norte" },
  { id: "Camarines Sur", name: "Camarines Sur" },
  { id: "Camiguin", name: "Camiguin" },
  { id: "Capiz", name: "Capiz" },
  { id: "Catanduanes", name: "Catanduanes" },
  { id: "Cavite", name: "Cavite" },
  { id: "Cebu", name: "Cebu" },
  { id: "Compostela Valley", name: "Compostela Valley" },
  { id: "Cotabato", name: "Cotabato" },
  { id: "Davao del Norte", name: "Davao del Norte" },
  { id: "Davao del Sur", name: "Davao del Sur" },
  { id: "Davao Occidental", name: "Davao Occidental" },
  { id: "Davao Oriental", name: "Davao Oriental" },
  { id: "Dinagat Islands", name: "Dinagat Islands" },
  { id: "Eastern Samar", name: "Eastern Samar" },
  { id: "Guimaras", name: "Guimaras" },
  { id: "Ifugao", name: "Ifugao" },
  { id: "Ilocos Norte", name: "Ilocos Norte" },
  { id: "Ilocos Sur", name: "Ilocos Sur" },
  { id: "Iloilo", name: "Iloilo" },
  { id: "Isabela", name: "Isabela" },
  { id: "Kalinga", name: "Kalinga" },
  { id: "La Union", name: "La Union" },
  { id: "Laguna", name: "Laguna" },
  { id: "Lanao del Norte", name: "Lanao del Norte" },
  { id: "Lanao del Sur", name: "Lanao del Sur" },
  { id: "Leyte", name: "Leyte" },
  { id: "Maguindanao", name: "Maguindanao" },
  { id: "Marinduque", name: "Marinduque" },
  { id: "Masbate", name: "Masbate" },
  { id: "Misamis Occidental", name: "Misamis Occidental" },
  { id: "Misamis Oriental", name: "Misamis Oriental" },
  { id: "Mountain Province", name: "Mountain Province" },
  { id: "NCR", name: "NCR" },
  { id: "Negros Occidental", name: "Negros Occidental" },
  { id: "Negros Oriental", name: "Negros Oriental" },
  { id: "Northern Samar", name: "Northern Samar" },
  { id: "Nueva Ecija", name: "Nueva Ecija" },
  { id: "Nueva Vizcaya", name: "Nueva Vizcaya" },
  { id: "Occidental Mindoro", name: "Occidental Mindoro" },
  { id: "Oriental Mindoro", name: "Oriental Mindoro" },
  { id: "Palawan", name: "Palawan" },
  { id: "Pampanga", name: "Pampanga" },
  { id: "Pangasinan", name: "Pangasinan" },
  { id: "Quezon", name: "Quezon" },
  { id: "Quirino", name: "Quirino" },
  { id: "Rizal", name: "Rizal" },
  { id: "Romblon", name: "Romblon" },
  { id: "Samar", name: "Samar" },
  { id: "Sarangani", name: "Sarangani" },
  { id: "Siquijor", name: "Siquijor" },
  { id: "Sorsogon", name: "Sorsogon" },
  { id: "South Cotabato", name: "South Cotabato" },
  { id: "Southern Leyte", name: "Southern Leyte" },
  { id: "Sultan Kudarat", name: "Sultan Kudarat" },
  { id: "Sulu", name: "Sulu" },
  { id: "Surigao del Norte", name: "Surigao del Norte" },
  { id: "Surigao del Sur", name: "Surigao del Sur" },
  { id: "Tarlac", name: "Tarlac" },
  { id: "Tawi-Tawi", name: "Tawi-Tawi" },
  { id: "Zambales", name: "Zambales" },
  { id: "Zamboanga del Norte", name: "Zamboanga del Norte" },
  { id: "Zamboanga del Sur", name: "Zamboanga del Sur" },
  { id: "Zamboanga Sibugay", name: "Zamboanga Sibugay" },
];

const cities = [
  { id: "Aborlan", name: "Aborlan" },
  { id: "Abra de Ilog", name: "Abra de Ilog" },
  { id: "Abucay", name: "Abucay" },
  { id: "Abulug", name: "Abulug" },
  { id: "Abuyog", name: "Abuyog" },
  { id: "Adams", name: "Adams" },
  { id: "Agdangan", name: "Agdangan" },
  { id: "Aglipay", name: "Aglipay" },
  { id: "Agno", name: "Agno" },
  { id: "Agoncillo", name: "Agoncillo" },
  { id: "Agoo", name: "Agoo" },
  { id: "Aguilar", name: "Aguilar" },
  { id: "Aguinaldo", name: "Aguinaldo" },
  { id: "Agutaya", name: "Agutaya" },
  { id: "Ajuy", name: "Ajuy" },
  { id: "Alabat", name: "Alabat" },
  { id: "Alabel", name: "Alabel" },
  { id: "Alamada", name: "Alamada" },
  { id: "Alaminos", name: "Alaminos" },
  { id: "Alaminos City", name: "Alaminos City" },
  { id: "Alangalang", name: "Alangalang" },
  { id: "Albuera", name: "Albuera" },
  { id: "Alburquerque", name: "Alburquerque" },
  { id: "Alcala", name: "Alcala" },
  { id: "Alcantara", name: "Alcantara" },
  { id: "Alcoy", name: "Alcoy" },
  { id: "Alegria", name: "Alegria" },
  { id: "Aleosan", name: "Aleosan" },
  { id: "Alfonso", name: "Alfonso" },
  { id: "Alfonso Castañeda", name: "Alfonso Castañeda" },
  { id: "Alfonso Lista (Potia)", name: "Alfonso Lista (Potia)" },
  { id: "Aliaga", name: "Aliaga" },
  { id: "Alicia", name: "Alicia" },
  { id: "Alilem", name: "Alilem" },
  { id: "Alimodian", name: "Alimodian" },
  { id: "Alitagtag", name: "Alitagtag" },
  { id: "Allacapan", name: "Allacapan" },
  { id: "Allen", name: "Allen" },
  { id: "Almagro", name: "Almagro" },
  { id: "Almeria", name: "Almeria" },
  { id: "Aloguinsan", name: "Aloguinsan" },
  { id: "Aloran", name: "Aloran" },
  { id: "Altavas", name: "Altavas" },
  { id: "Alubijid", name: "Alubijid" },
  { id: "Amadeo", name: "Amadeo" },
  { id: "Ambaguio", name: "Ambaguio" },
  { id: "Amlan", name: "Amlan" },
  { id: "Ampatuan", name: "Ampatuan" },
  { id: "Amulung", name: "Amulung" },
  { id: "Anahawan", name: "Anahawan" },
  { id: "Anao", name: "Anao" },
  { id: "Anda", name: "Anda" },
  { id: "Angadanan", name: "Angadanan" },
  { id: "Angat", name: "Angat" },
  { id: "Angeles City", name: "Angeles City" },
  { id: "Angono", name: "Angono" },
  { id: "Anilao", name: "Anilao" },
  { id: "Anini-y", name: "Anini-y" },
  { id: "Antequera", name: "Antequera" },
  { id: "Antipas", name: "Antipas" },
  { id: "Antipolo", name: "Antipolo" },
  { id: "Apalit", name: "Apalit" },
  { id: "Aparri", name: "Aparri" },
  { id: "Araceli", name: "Araceli" },
  { id: "Arakan", name: "Arakan" },
  { id: "Arayat", name: "Arayat" },
  { id: "Argao", name: "Argao" },
  { id: "Aringay", name: "Aringay" },
  { id: "Aritao", name: "Aritao" },
  { id: "Aroroy", name: "Aroroy" },
  { id: "Arteche", name: "Arteche" },
  { id: "Asingan", name: "Asingan" },
  { id: "Asipulo", name: "Asipulo" },
  { id: "Asturias", name: "Asturias" },
  { id: "Asuncion", name: "Asuncion" },
  { id: "Atimonan", name: "Atimonan" },
  { id: "Atok", name: "Atok" },
  { id: "Aurora", name: "Aurora" },
  { id: "Ayungon", name: "Ayungon" },
  { id: "Baao", name: "Baao" },
  { id: "Babak", name: "Babak" },
  { id: "Babatngon", name: "Babatngon" },
  { id: "Bacacay", name: "Bacacay" },
  { id: "Bacarra", name: "Bacarra" },
  { id: "Baclayon", name: "Baclayon" },
  { id: "Bacnotan", name: "Bacnotan" },
  { id: "Baco", name: "Baco" },
  { id: "Bacolod", name: "Bacolod" },
  { id: "Bacolod City", name: "Bacolod City" },
  { id: "Bacolod Grande", name: "Bacolod Grande" },
  { id: "Bacolor", name: "Bacolor" },
  { id: "Bacon", name: "Bacon" },
  { id: "Bacong", name: "Bacong" },
  { id: "Bacoor City", name: "Bacoor City" },
  { id: "Bacuag", name: "Bacuag" },
  { id: "Badian", name: "Badian" },
  { id: "Badiangan", name: "Badiangan" },
  { id: "Badoc", name: "Badoc" },
  { id: "Bagabag", name: "Bagabag" },
  { id: "Bagac", name: "Bagac" },
  { id: "Bagamanoc", name: "Bagamanoc" },
  { id: "Baganga", name: "Baganga" },
  { id: "Baggao", name: "Baggao" },
  { id: "Bago City", name: "Bago City" },
  { id: "Baguio", name: "Baguio" },
  { id: "Bagulin", name: "Bagulin" },
  { id: "Bagumbayan", name: "Bagumbayan" },
  { id: "Bais City", name: "Bais City" },
  { id: "Bakun", name: "Bakun" },
  { id: "Balabac", name: "Balabac" },
  { id: "Balabagan", name: "Balabagan" },
  { id: "Balagtas (Bigaa)", name: "Balagtas (Bigaa)" },
  { id: "Balamban", name: "Balamban" },
  { id: "Balanga City", name: "Balanga City" },
  { id: "Balangiga", name: "Balangiga" },
  { id: "Balangkayan", name: "Balangkayan" },
  { id: "Balaoan", name: "Balaoan" },
  { id: "Balasan", name: "Balasan" },
  { id: "Balatan", name: "Balatan" },
  { id: "Balayan", name: "Balayan" },
  { id: "Balbalan", name: "Balbalan" },
  { id: "Baleno", name: "Baleno" },
  { id: "Baler", name: "Baler" },
  { id: "Balete", name: "Balete" },
  { id: "Baliangao", name: "Baliangao" },
  { id: "Baliguian", name: "Baliguian" },
  { id: "Balilihan", name: "Balilihan" },
  { id: "Balindong", name: "Balindong" },
  { id: "Balingasag", name: "Balingasag" },
  { id: "Balingoan", name: "Balingoan" },
  { id: "Baliuag", name: "Baliuag" },
  { id: "Ballesteros", name: "Ballesteros" },
  { id: "Baloi", name: "Baloi" },
  { id: "Balud", name: "Balud" },
  { id: "Balungao", name: "Balungao" },
  { id: "Bamban", name: "Bamban" },
  { id: "Bambang", name: "Bambang" },
  { id: "Banate", name: "Banate" },
  { id: "Banaue", name: "Banaue" },
  { id: "Banaybanay", name: "Banaybanay" },
  { id: "Banayoyo", name: "Banayoyo" },
  { id: "Banga", name: "Banga" },
  { id: "Bangar", name: "Bangar" },
  { id: "Bangued", name: "Bangued" },
  { id: "Bangui", name: "Bangui" },
  { id: "Banguingui (Tongkil)", name: "Banguingui (Tongkil)" },
  { id: "Bani", name: "Bani" },
  { id: "Banisilan", name: "Banisilan" },
  { id: "Banna (Espiritu)", name: "Banna (Espiritu)" },
  { id: "Bansalan", name: "Bansalan" },
  { id: "Bansud", name: "Bansud" },
  { id: "Bantay", name: "Bantay" },
  { id: "Bantayan", name: "Bantayan" },
  { id: "Banton (Jones)", name: "Banton (Jones)" },
  { id: "Baras", name: "Baras" },
  { id: "Barbaza", name: "Barbaza" },
  { id: "Barcelona", name: "Barcelona" },
  { id: "Barili", name: "Barili" },
  { id: "Barira", name: "Barira" },
  { id: "Barlig", name: "Barlig" },
  { id: "Barobo", name: "Barobo" },
  { id: "Barotac Nuevo", name: "Barotac Nuevo" },
  { id: "Barotac Viejo", name: "Barotac Viejo" },
  { id: "Baroy", name: "Baroy" },
  { id: "Barugo", name: "Barugo" },
  { id: "Basa Airbase", name: "Basa Airbase" },
  { id: "Basay", name: "Basay" },
  { id: "Basco", name: "Basco" },
  { id: "Basey", name: "Basey" },
  { id: "Basilisa (Rizal)", name: "Basilisa (Rizal)" },
  { id: "Basista", name: "Basista" },
  { id: "Basud", name: "Basud" },
  {
    id: "Bataan Export Processing Zone (Mariveles)",
    name: "Bataan Export Processing Zone (Mariveles)",
  },
  { id: "Batac", name: "Batac" },
  { id: "Batad", name: "Batad" },
  { id: "Batan", name: "Batan" },
  { id: "Batangas City", name: "Batangas City" },
  { id: "Bataraza", name: "Bataraza" },
  { id: "Bato", name: "Bato" },
  { id: "Batuan", name: "Batuan" },
  { id: "Bauan", name: "Bauan" },
  { id: "Bauang", name: "Bauang" },
  { id: "Bauko", name: "Bauko" },
  { id: "Baungon", name: "Baungon" },
  { id: "Bautista", name: "Bautista" },
  { id: "Bay", name: "Bay" },
  { id: "Bayabas", name: "Bayabas" },
  { id: "Bayambang", name: "Bayambang" },
  { id: "Bayang", name: "Bayang" },
  { id: "Bayawan", name: "Bayawan" },
  { id: "Baybay", name: "Baybay" },
  { id: "Bayog", name: "Bayog" },
  { id: "Bayombong", name: "Bayombong" },
  { id: "Bayugan", name: "Bayugan" },
  { id: "Belison", name: "Belison" },
  { id: "Benito Soliven", name: "Benito Soliven" },
  { id: "Besao", name: "Besao" },
  { id: "Bien Unido", name: "Bien Unido" },
  { id: "Bilar", name: "Bilar" },
  { id: "Biliran", name: "Biliran" },
  { id: "Binalbagan", name: "Binalbagan" },
  { id: "Binalonan", name: "Binalonan" },
  { id: "Biñan City", name: "Biñan City" },
  { id: "Binangonan", name: "Binangonan" },
  { id: "Bindoy", name: "Bindoy" },
  { id: "Bingawan", name: "Bingawan" },
  { id: "Binidayan", name: "Binidayan" },
  { id: "Binmaley", name: "Binmaley" },
  { id: "Binuangan", name: "Binuangan" },
  { id: "Biri", name: "Biri" },
  { id: "Bislig", name: "Bislig" },
  { id: "Boac", name: "Boac" },
  { id: "Bobon", name: "Bobon" },
  { id: "Bocaue", name: "Bocaue" },
  { id: "Bogo City", name: "Bogo City" },
  { id: "Bokod", name: "Bokod" },
  { id: "Bolinao", name: "Bolinao" },
  { id: "Boliney", name: "Boliney" },
  { id: "Boljoon", name: "Boljoon" },
  { id: "Bombon", name: "Bombon" },
  { id: "Bongabon", name: "Bongabon" },
  { id: "Bongabong", name: "Bongabong" },
  { id: "Bongao", name: "Bongao" },
  { id: "Bonifacio", name: "Bonifacio" },
  { id: "Bontoc", name: "Bontoc" },
  { id: "Borbon", name: "Borbon" },
  { id: "Borongan", name: "Borongan" },
  { id: "Boston", name: "Boston" },
  { id: "Botocan, Magdalena", name: "Botocan, Magdalena" },
  { id: "Botolan", name: "Botolan" },
  { id: "Brookes Point", name: "Brookes Point" },
  { id: "Buadiposo-Buntong", name: "Buadiposo-Buntong" },
  { id: "Bubong", name: "Bubong" },
  { id: "Bucay", name: "Bucay" },
  { id: "Bucloc", name: "Bucloc" },
  { id: "Buenavista", name: "Buenavista" },
  { id: "Bugallon", name: "Bugallon" },
  { id: "Bugasong", name: "Bugasong" },
  { id: "Buguey", name: "Buguey" },
  { id: "Buguias", name: "Buguias" },
  { id: "Buhi", name: "Buhi" },
  { id: "Bula", name: "Bula" },
  { id: "Bulacan", name: "Bulacan" },
  { id: "Bulalacao", name: "Bulalacao" },
  { id: "Bulan", name: "Bulan" },
  { id: "Buldon", name: "Buldon" },
  { id: "Buluan", name: "Buluan" },
  { id: "Bulusan", name: "Bulusan" },
  { id: "Bumbaran", name: "Bumbaran" },
  { id: "Bunawan", name: "Bunawan" },
  { id: "Burauen", name: "Burauen" },
  { id: "Burdeos", name: "Burdeos" },
  { id: "Burgos", name: "Burgos" },
  { id: "Buruanga", name: "Buruanga" },
  { id: "Bustos", name: "Bustos" },
  { id: "Busuanga", name: "Busuanga" },
  { id: "Butig", name: "Butig" },
  { id: "Butuan", name: "Butuan" },
  { id: "Buug", name: "Buug" },
  { id: "Caba", name: "Caba" },
  { id: "Cabadbaran", name: "Cabadbaran" },
  { id: "Cabagan", name: "Cabagan" },
  { id: "Cabanatuan", name: "Cabanatuan" },
  { id: "Cabangan", name: "Cabangan" },
  { id: "Cabanglasan", name: "Cabanglasan" },
  { id: "Cabarroguis", name: "Cabarroguis" },
  { id: "Cabatuan", name: "Cabatuan" },
  { id: "Cabiao", name: "Cabiao" },
  { id: "Cabucgayan", name: "Cabucgayan" },
  { id: "Cabugao", name: "Cabugao" },
  { id: "Cabusao", name: "Cabusao" },
  { id: "Cabuyao City", name: "Cabuyao City" },
  { id: "Cadiz City", name: "Cadiz City" },
  { id: "Cagayan de Oro", name: "Cagayan de Oro" },
  { id: "Cagayancillo", name: "Cagayancillo" },
  { id: "Cagdianao", name: "Cagdianao" },
  { id: "Cagwait", name: "Cagwait" },
  { id: "Caibiran", name: "Caibiran" },
  { id: "Cainta", name: "Cainta" },
  { id: "Cajidiocan", name: "Cajidiocan" },
  { id: "Calabanga", name: "Calabanga" },
  { id: "Calaca", name: "Calaca" },
  { id: "Calamba", name: "Calamba" },
  { id: "Calamba City", name: "Calamba City" },
  { id: "Calanasan (Bayag)", name: "Calanasan (Bayag)" },
  { id: "Calanogas", name: "Calanogas" },
  { id: "Calapan", name: "Calapan" },
  { id: "Calape", name: "Calape" },
  { id: "Calasiao", name: "Calasiao" },
  { id: "Calatagan", name: "Calatagan" },
  { id: "Calatrava", name: "Calatrava" },
  { id: "Calauag", name: "Calauag" },
  { id: "Calauan", name: "Calauan" },
  { id: "Calayan", name: "Calayan" },
  { id: "Calbayog", name: "Calbayog" },
  { id: "Calbiga", name: "Calbiga" },
  { id: "Calinog", name: "Calinog" },
  { id: "Calintaan", name: "Calintaan" },
  { id: "Callocan City (South)", name: "Callocan City (South)" },
  { id: "Caloocan City (North)", name: "Caloocan City (North)" },
  { id: "Calubian", name: "Calubian" },
  { id: "Calumpit", name: "Calumpit" },
  { id: "Caluya", name: "Caluya" },
  { id: "Camalaniugan", name: "Camalaniugan" },
  { id: "Camalig", name: "Camalig" },
  { id: "Camaligan", name: "Camaligan" },
  { id: "Camiling", name: "Camiling" },
  { id: "Camp Phillips", name: "Camp Phillips" },
  {
    id: "Camp Vicente Lim, Calamba City",
    name: "Camp Vicente Lim, Calamba City",
  },
  { id: "Can-avid", name: "Can-avid" },
  { id: "Canaman", name: "Canaman" },
  { id: "Candaba", name: "Candaba" },
  { id: "Candelaria", name: "Candelaria" },
  { id: "Candijay", name: "Candijay" },
  { id: "Candon", name: "Candon" },
  { id: "Candoni", name: "Candoni" },
  { id: "Canlaon", name: "Canlaon" },
  { id: "Canlubang, Calamba City", name: "Canlubang, Calamba City" },
  { id: "Cantilan", name: "Cantilan" },
  { id: "Caoayan", name: "Caoayan" },
  { id: "Capalonga", name: "Capalonga" },
  { id: "Capas", name: "Capas" },
  { id: "Capoocan", name: "Capoocan" },
  { id: "Capul", name: "Capul" },
  { id: "Caraga", name: "Caraga" },
  { id: "Caramoan", name: "Caramoan" },
  { id: "Caramoran", name: "Caramoran" },
  { id: "Carasi", name: "Carasi" },
  { id: "Carcar", name: "Carcar" },
  { id: "Cardona", name: "Cardona" },
  { id: "Carigara", name: "Carigara" },
  { id: "Carles", name: "Carles" },
  { id: "Carmen", name: "Carmen" },
  { id: "Carmona", name: "Carmona" },
  { id: "Carranglan", name: "Carranglan" },
  { id: "Carrascal", name: "Carrascal" },
  { id: "Casiguran", name: "Casiguran" },
  { id: "Castilla", name: "Castilla" },
  { id: "Castillejos", name: "Castillejos" },
  { id: "Cataingan", name: "Cataingan" },
  { id: "Catanauan", name: "Catanauan" },
  { id: "Catarman", name: "Catarman" },
  { id: "Catbalogan", name: "Catbalogan" },
  { id: "Cateel", name: "Cateel" },
  { id: "Catigbian", name: "Catigbian" },
  { id: "Catmon", name: "Catmon" },
  { id: "Catubig", name: "Catubig" },
  { id: "Cauayan", name: "Cauayan" },
  { id: "Cauayan City", name: "Cauayan City" },
  { id: "Cavinti", name: "Cavinti" },
  { id: "Cavite City", name: "Cavite City" },
  { id: "Cawayan", name: "Cawayan" },
  { id: "Cebu City", name: "Cebu City" },
  {
    id: "Central Luzon State University",
    name: "Central Luzon State University",
  },
  { id: "Cervantes", name: "Cervantes" },
  { id: "City of San Fernando", name: "City of San Fernando" },
  { id: "Clarin", name: "Clarin" },
  { id: "Clark Freeport Zone", name: "Clark Freeport Zone" },
  { id: "Claver", name: "Claver" },
  { id: "Claveria", name: "Claveria" },
  { id: "Columbio", name: "Columbio" },
  { id: "Compostela", name: "Compostela" },
  { id: "Concepcion", name: "Concepcion" },
  { id: "Conner", name: "Conner" },
  { id: "Consolacion", name: "Consolacion" },
  { id: "Corcuera", name: "Corcuera" },
  { id: "Cordon", name: "Cordon" },
  { id: "Cordova", name: "Cordova" },
  { id: "Corella", name: "Corella" },
  { id: "Coron", name: "Coron" },
  { id: "Corregidor Island", name: "Corregidor Island" },
  { id: "Cortes", name: "Cortes" },
  { id: "Cotabato City", name: "Cotabato City" },
  { id: "Cuartero", name: "Cuartero" },
  { id: "Cuenca", name: "Cuenca" },
  { id: "Culaba", name: "Culaba" },
  { id: "Culasi", name: "Culasi" },
  { id: "Culion", name: "Culion" },
  { id: "Currimao", name: "Currimao" },
  { id: "Cuyapo", name: "Cuyapo" },
  { id: "Cuyo", name: "Cuyo" },
  { id: "Daanbantayan", name: "Daanbantayan" },
  { id: "Daet", name: "Daet" },
  { id: "Dagami", name: "Dagami" },
  { id: "Dagohoy", name: "Dagohoy" },
  { id: "Daguioman", name: "Daguioman" },
  { id: "Dagupan", name: "Dagupan" },
  { id: "Dalaguete", name: "Dalaguete" },
  { id: "Damulog", name: "Damulog" },
  { id: "Danao", name: "Danao" },
  { id: "Danao City", name: "Danao City" },
  { id: "Dangcagan", name: "Dangcagan" },
  { id: "Danglas", name: "Danglas" },
  { id: "Dao", name: "Dao" },
  { id: "Dapa", name: "Dapa" },
  { id: "Dapitan", name: "Dapitan" },
  { id: "Daraga (Locsin)", name: "Daraga (Locsin)" },
  { id: "Daram", name: "Daram" },
  { id: "Dasmariñas", name: "Dasmariñas" },
  {
    id: "Dasmariñas Resettlement Area (Dasmariñas City)",
    name: "Dasmariñas Resettlement Area (Dasmariñas City)",
  },
  { id: "Dasol", name: "Dasol" },
  { id: "Datu Abdullah Sangki", name: "Datu Abdullah Sangki" },
  { id: "Datu Anggal Midtimbang", name: "Datu Anggal Midtimbang" },
  { id: "Datu Blah T. Sinsuat", name: "Datu Blah T. Sinsuat" },
  { id: "Datu Hoffer Ampatuan", name: "Datu Hoffer Ampatuan" },
  { id: "Datu Odin Sinsuat (Dinaig)", name: "Datu Odin Sinsuat (Dinaig)" },
  { id: "Datu Paglas", name: "Datu Paglas" },
  { id: "Datu Piang", name: "Datu Piang" },
  { id: "Datu Salibo", name: "Datu Salibo" },
  { id: "Datu Saudi-Ampatuan", name: "Datu Saudi-Ampatuan" },
  { id: "Datu Unsay", name: "Datu Unsay" },
  { id: "Dauin", name: "Dauin" },
  { id: "Dauis", name: "Dauis" },
  { id: "Davao City", name: "Davao City" },
  { id: "Del Carmen", name: "Del Carmen" },
  { id: "Del Gallego", name: "Del Gallego" },
  { id: "Delfin Albano", name: "Delfin Albano" },
  { id: "Diadi", name: "Diadi" },
  { id: "Diffun", name: "Diffun" },
  { id: "Digos", name: "Digos" },
  { id: "Dilasag", name: "Dilasag" },
  { id: "Dimasalang", name: "Dimasalang" },
  { id: "Dimataling", name: "Dimataling" },
  { id: "Dimiao", name: "Dimiao" },
  { id: "Dinagat", name: "Dinagat" },
  { id: "Dinalungan", name: "Dinalungan" },
  { id: "Dinalupihan", name: "Dinalupihan" },
  { id: "Dinapigui", name: "Dinapigui" },
  { id: "Dinas", name: "Dinas" },
  { id: "Dingalan", name: "Dingalan" },
  { id: "Dingle", name: "Dingle" },
  { id: "Dingras", name: "Dingras" },
  { id: "Dipaculao", name: "Dipaculao" },
  { id: "Diplahan", name: "Diplahan" },
  { id: "Dipolog", name: "Dipolog" },
  { id: "Ditsaan-Ramain", name: "Ditsaan-Ramain" },
  { id: "Divilacan", name: "Divilacan" },
  { id: "Dolores", name: "Dolores" },
  { id: "Don Carlos", name: "Don Carlos" },
  { id: "Don Marcelino", name: "Don Marcelino" },
  { id: "Doña Remedios Trinidad", name: "Doña Remedios Trinidad" },
  { id: "Donsol", name: "Donsol" },
  { id: "Duenas", name: "Duenas" },
  { id: "Duero", name: "Duero" },
  { id: "Dulag", name: "Dulag" },
  { id: "Dumaguete", name: "Dumaguete" },
  { id: "Dumalag", name: "Dumalag" },
  { id: "Dumalinao", name: "Dumalinao" },
  { id: "Dumalneg", name: "Dumalneg" },
  { id: "Dumangas", name: "Dumangas" },
  { id: "Dumanjug", name: "Dumanjug" },
  { id: "Dumaran", name: "Dumaran" },
  { id: "Dumarao", name: "Dumarao" },
  { id: "Dumingag", name: "Dumingag" },
  { id: "Dupax del Norte", name: "Dupax del Norte" },
  { id: "Dupax del Sur", name: "Dupax del Sur" },
  { id: "Echague", name: "Echague" },
  { id: "El Nido (Bacuit)", name: "El Nido (Bacuit)" },
  { id: "El Salvador", name: "El Salvador" },
  { id: "Enrile", name: "Enrile" },
  { id: "Enrique B. Magalona", name: "Enrique B. Magalona" },
  { id: "Enrique Villanueva", name: "Enrique Villanueva" },
  { id: "Escalante City", name: "Escalante City" },
  { id: "Esperanza", name: "Esperanza" },
  { id: "Estancia", name: "Estancia" },
  { id: "Famy", name: "Famy" },
  {
    id: "Fernando Air Base (Lipa City)",
    name: "Fernando Air Base (Lipa City)",
  },
  { id: "Ferrol", name: "Ferrol" },
  {
    id: "First Cavite Industrial Estate (Dasmariñas City)",
    name: "First Cavite Industrial Estate (Dasmariñas City)",
  },
  { id: "Flora", name: "Flora" },
  { id: "Floridablanca", name: "Floridablanca" },
  { id: "Fort Magsaysay", name: "Fort Magsaysay" },
  { id: "Gabaldon", name: "Gabaldon" },
  { id: "Gainza", name: "Gainza" },
  { id: "Galimuyod", name: "Galimuyod" },
  { id: "Gamay", name: "Gamay" },
  { id: "Gamu", name: "Gamu" },
  { id: "Ganassi", name: "Ganassi" },
  { id: "Gandara", name: "Gandara" },
  { id: "Gapan", name: "Gapan" },
  { id: "Garchitorena", name: "Garchitorena" },
  { id: "Garcia Hernandez", name: "Garcia Hernandez" },
  { id: "Gasan", name: "Gasan" },
  { id: "Gattaran", name: "Gattaran" },
  { id: "Gen. S.K. Pendatun", name: "Gen. S.K. Pendatun" },
  {
    id: "General Emilio Aguinaldo (Bailen)",
    name: "General Emilio Aguinaldo (Bailen)",
  },
  { id: "General Luna", name: "General Luna" },
  { id: "General Luna, Quezon", name: "General Luna, Quezon" },
  { id: "General MacArthur", name: "General MacArthur" },
  { id: "General Mamerto Natividad", name: "General Mamerto Natividad" },
  { id: "General Mariano Alvarez", name: "General Mariano Alvarez" },
  { id: "General Nakar", name: "General Nakar" },
  { id: "General Santos (Dadiangas)", name: "General Santos (Dadiangas)" },
  { id: "General Tinio", name: "General Tinio" },
  { id: "General Trias City", name: "General Trias City" },
  { id: "Gerona", name: "Gerona" },
  { id: "Gigaquit", name: "Gigaquit" },
  { id: "Gigmoto", name: "Gigmoto" },
  { id: "Ginatilan", name: "Ginatilan" },
  { id: "Gingoog", name: "Gingoog" },
  { id: "Giporlos", name: "Giporlos" },
  { id: "Gitagum", name: "Gitagum" },
  { id: "Glan", name: "Glan" },
  { id: "Gloria", name: "Gloria" },
  { id: "Goa", name: "Goa" },
  { id: "Gonzaga", name: "Gonzaga" },
  { id: "Governor Generoso", name: "Governor Generoso" },
  { id: "Gregorio del Pilar", name: "Gregorio del Pilar" },
  { id: "Guagua", name: "Guagua" },
  { id: "Gubat", name: "Gubat" },
  { id: "Guiguinto", name: "Guiguinto" },
  { id: "Guihulngan", name: "Guihulngan" },
  { id: "Guimba", name: "Guimba" },
  { id: "Guimbal", name: "Guimbal" },
  { id: "Guinayangan", name: "Guinayangan" },
  { id: "Guindulman", name: "Guindulman" },
  { id: "Guindulungan", name: "Guindulungan" },
  { id: "Guinobatan", name: "Guinobatan" },
  { id: "Guinsiliban", name: "Guinsiliban" },
  { id: "Guipos", name: "Guipos" },
  { id: "Guiuan", name: "Guiuan" },
  { id: "Gumaca", name: "Gumaca" },
  { id: "Gutalac", name: "Gutalac" },
  { id: "Hadji Panglima Tahil", name: "Hadji Panglima Tahil" },
  { id: "Hagonoy", name: "Hagonoy" },
  { id: "Hamtic", name: "Hamtic" },
  { id: "Hermosa", name: "Hermosa" },
  { id: "Hernani", name: "Hernani" },
  { id: "Hilongos", name: "Hilongos" },
  { id: "Himamaylan", name: "Himamaylan" },
  { id: "Hinabangan", name: "Hinabangan" },
  { id: "Hinatuan", name: "Hinatuan" },
  { id: "Hindang", name: "Hindang" },
  { id: "Hingyon", name: "Hingyon" },
  { id: "Hinigaran", name: "Hinigaran" },
  { id: "Hinoba-an", name: "Hinoba-an" },
  { id: "Hinunangan", name: "Hinunangan" },
  { id: "Hinundayan", name: "Hinundayan" },
  { id: "Hondagua, Lopez", name: "Hondagua, Lopez" },
  { id: "Hungduan", name: "Hungduan" },
  { id: "Iba", name: "Iba" },
  { id: "Ibaan", name: "Ibaan" },
  { id: "Ibajay", name: "Ibajay" },
  { id: "Igbaras", name: "Igbaras" },
  { id: "Iguig", name: "Iguig" },
  { id: "Ilagan", name: "Ilagan" },
  { id: "Iligan", name: "Iligan" },
  { id: "Ilog", name: "Ilog" },
  { id: "Iloilo City", name: "Iloilo City" },
  { id: "Imelda", name: "Imelda" },
  { id: "Impasugong", name: "Impasugong" },
  { id: "Imus City", name: "Imus City" },
  { id: "Inabanga", name: "Inabanga" },
  { id: "Indanan", name: "Indanan" },
  { id: "Indang", name: "Indang" },
  { id: "Infanta", name: "Infanta" },
  { id: "Initao", name: "Initao" },
  { id: "Inopacan", name: "Inopacan" },
  { id: "Ipil", name: "Ipil" },
  { id: "Iriga", name: "Iriga" },
  { id: "Irosin", name: "Irosin" },
  { id: "Isabel", name: "Isabel" },
  { id: "Isabela", name: "Isabela" },
  { id: "Isabela City", name: "Isabela City" },
  { id: "Isulan", name: "Isulan" },
  { id: "Itbayat", name: "Itbayat" },
  { id: "Itogon", name: "Itogon" },
  { id: "Ivana", name: "Ivana" },
  { id: "Ivisan", name: "Ivisan" },
  { id: "Iwahig Penal Colony", name: "Iwahig Penal Colony" },
  { id: "Jabonga", name: "Jabonga" },
  { id: "Jaen", name: "Jaen" },
  { id: "Jagna", name: "Jagna" },
  { id: "Jalajala", name: "Jalajala" },
  { id: "Jamindan", name: "Jamindan" },
  { id: "Janiuay", name: "Janiuay" },
  { id: "Jaro", name: "Jaro" },
  { id: "Jasaan", name: "Jasaan" },
  { id: "Javier", name: "Javier" },
  { id: "Jetafe", name: "Jetafe" },
  { id: "Jiabong", name: "Jiabong" },
  { id: "Jimalalud", name: "Jimalalud" },
  { id: "Jimenez", name: "Jimenez" },
  { id: "Jipapad", name: "Jipapad" },
  { id: "Jolo & Pandami", name: "Jolo & Pandami" },
  { id: "Jomalig", name: "Jomalig" },
  { id: "Jones", name: "Jones" },
  { id: "Jordan", name: "Jordan" },
  { id: "Jose Abad Santos", name: "Jose Abad Santos" },
  { id: "Jose Dalman (Ponot)", name: "Jose Dalman (Ponot)" },
  { id: "Jose Panganiban", name: "Jose Panganiban" },
  { id: "Josefina", name: "Josefina" },
  { id: "Jovellar", name: "Jovellar" },
  { id: "Juban", name: "Juban" },
  { id: "Julita", name: "Julita" },
  { id: "Kabacan", name: "Kabacan" },
  { id: "Kabankalan", name: "Kabankalan" },
  { id: "Kabasalan", name: "Kabasalan" },
  { id: "Kabayan", name: "Kabayan" },
  { id: "Kabugao", name: "Kabugao" },
  { id: "Kabuntalan", name: "Kabuntalan" },
  { id: "Kadingilan", name: "Kadingilan" },
  { id: "Kalamansig", name: "Kalamansig" },
  { id: "Kalawit", name: "Kalawit" },
  { id: "Kalayaan", name: "Kalayaan" },
  { id: "Kalayaan (Spratly Islands)", name: "Kalayaan (Spratly Islands)" },
  { id: "Kalibo", name: "Kalibo" },
  { id: "Kalilangan", name: "Kalilangan" },
  { id: "Kalingalan Calauang", name: "Kalingalan Calauang" },
  { id: "Kananga", name: "Kananga" },
  { id: "Kapai", name: "Kapai" },
  { id: "Kapalong", name: "Kapalong" },
  { id: "Kapangan", name: "Kapangan" },
  { id: "Kapatagan", name: "Kapatagan" },
  { id: "Kaputian", name: "Kaputian" },
  { id: "Kasibu", name: "Kasibu" },
  { id: "Katipunan", name: "Katipunan" },
  { id: "Kauswagan", name: "Kauswagan" },
  { id: "Kawayan", name: "Kawayan" },
  { id: "Kawit", name: "Kawit" },
  { id: "Kayapa", name: "Kayapa" },
  { id: "Kiamba", name: "Kiamba" },
  { id: "Kiangan", name: "Kiangan" },
  { id: "Kibawe", name: "Kibawe" },
  { id: "Kiblawan", name: "Kiblawan" },
  { id: "Kibungan", name: "Kibungan" },
  { id: "Kidapawan", name: "Kidapawan" },
  { id: "Kinoguitan", name: "Kinoguitan" },
  { id: "Kitaotao", name: "Kitaotao" },
  { id: "Kitcharao", name: "Kitcharao" },
  { id: "Kolambugan", name: "Kolambugan" },
  { id: "Koronadal", name: "Koronadal" },
  { id: "Kumalarang", name: "Kumalarang" },
  { id: "La Carlota City", name: "La Carlota City" },
  { id: "La Castellana", name: "La Castellana" },
  { id: "La Libertad", name: "La Libertad" },
  { id: "La Paz", name: "La Paz" },
  { id: "La Trinidad", name: "La Trinidad" },
  { id: "Laak (San Vicente)", name: "Laak (San Vicente)" },
  { id: "Labangan", name: "Labangan" },
  { id: "Labason", name: "Labason" },
  { id: "Labo", name: "Labo" },
  { id: "Labrador", name: "Labrador" },
  { id: "Lacub", name: "Lacub" },
  { id: "Lagangilang", name: "Lagangilang" },
  { id: "Lagawe", name: "Lagawe" },
  { id: "Lagayan", name: "Lagayan" },
  { id: "Lagonglong", name: "Lagonglong" },
  { id: "Lagonoy", name: "Lagonoy" },
  { id: "Laguindingan", name: "Laguindingan" },
  { id: "Lake Sebu", name: "Lake Sebu" },
  { id: "Lakewood", name: "Lakewood" },
  { id: "Lal-Lo", name: "Lal-Lo" },
  { id: "Lala", name: "Lala" },
  { id: "Lamao", name: "Lamao" },
  { id: "Lambayong", name: "Lambayong" },
  { id: "Lambunao", name: "Lambunao" },
  { id: "Lamitan", name: "Lamitan" },
  { id: "Lamut", name: "Lamut" },
  { id: "Langiden", name: "Langiden" },
  { id: "Languyan", name: "Languyan" },
  { id: "Lantapan", name: "Lantapan" },
  { id: "Lantawan", name: "Lantawan" },
  { id: "Lanuza", name: "Lanuza" },
  { id: "Laoac", name: "Laoac" },
  { id: "Laoag", name: "Laoag" },
  { id: "Laoang", name: "Laoang" },
  { id: "Lapinig", name: "Lapinig" },
  { id: "Lapu-Lapu City (Opon)", name: "Lapu-Lapu City (Opon)" },
  { id: "Lapuyan", name: "Lapuyan" },
  { id: "Larena", name: "Larena" },
  { id: "Las Navas", name: "Las Navas" },
  { id: "Las Nieves", name: "Las Nieves" },
  { id: "Las Pinas City", name: "Las Pinas City" },
  { id: "Lasam", name: "Lasam" },
  { id: "Laua-an", name: "Laua-an" },
  { id: "Laur", name: "Laur" },
  { id: "Laurel", name: "Laurel" },
  { id: "Lavezares", name: "Lavezares" },
  { id: "Lawaan", name: "Lawaan" },
  { id: "Lazi", name: "Lazi" },
  { id: "Lebak", name: "Lebak" },
  { id: "Leganes", name: "Leganes" },
  { id: "Legazpi City", name: "Legazpi City" },
  { id: "Lemery", name: "Lemery" },
  { id: "Leon", name: "Leon" },
  { id: "Leon B. Postigo", name: "Leon B. Postigo" },
  { id: "Lepanto", name: "Lepanto" },
  { id: "Leyte", name: "Leyte" },
  { id: "Lezo", name: "Lezo" },
  { id: "Lian", name: "Lian" },
  { id: "Lianga", name: "Lianga" },
  { id: "Libacao", name: "Libacao" },
  { id: "Libagon", name: "Libagon" },
  { id: "Libertad", name: "Libertad" },
  { id: "Libjo (Albor)", name: "Libjo (Albor)" },
  { id: "Libmanan", name: "Libmanan" },
  { id: "Libon", name: "Libon" },
  { id: "Libona", name: "Libona" },
  { id: "Libungan", name: "Libungan" },
  { id: "Licab", name: "Licab" },
  { id: "Licuan-Baay", name: "Licuan-Baay" },
  { id: "Lidlidda", name: "Lidlidda" },
  { id: "Ligao", name: "Ligao" },
  { id: "Lila", name: "Lila" },
  { id: "Liliw", name: "Liliw" },
  { id: "Liloan", name: "Liloan" },
  { id: "Liloy", name: "Liloy" },
  { id: "Limasawa", name: "Limasawa" },
  { id: "Limay", name: "Limay" },
  { id: "Linamon", name: "Linamon" },
  { id: "Linapacan", name: "Linapacan" },
  { id: "Lingayen", name: "Lingayen" },
  { id: "Lingig", name: "Lingig" },
  { id: "Lipa City", name: "Lipa City" },
  { id: "Llanera", name: "Llanera" },
  { id: "Llorente", name: "Llorente" },
  { id: "Loay", name: "Loay" },
  { id: "Lobo", name: "Lobo" },
  { id: "Loboc", name: "Loboc" },
  { id: "Looc", name: "Looc" },
  { id: "Loon", name: "Loon" },
  { id: "Lope de Vega", name: "Lope de Vega" },
  { id: "Lopez", name: "Lopez" },
  { id: "Lopez Jaena", name: "Lopez Jaena" },
  { id: "Loreto", name: "Loreto" },
  { id: "Los Baños", name: "Los Baños" },
  { id: "Luba", name: "Luba" },
  { id: "Lubang", name: "Lubang" },
  { id: "Lubao", name: "Lubao" },
  { id: "Lubuagan", name: "Lubuagan" },
  { id: "Lucban", name: "Lucban" },
  { id: "Lucena City", name: "Lucena City" },
  { id: "Lugait", name: "Lugait" },
  { id: "Lugus", name: "Lugus" },
  { id: "Luisiana", name: "Luisiana" },
  { id: "Lumba-Bayabao", name: "Lumba-Bayabao" },
  {
    id: "Lumbaca-Unayan and Macadar Andong",
    name: "Lumbaca-Unayan and Macadar Andong",
  },
  { id: "Lumban", name: "Lumban" },
  { id: "Lumbatan", name: "Lumbatan" },
  { id: "Lumbayanague", name: "Lumbayanague" },
  { id: "Luna", name: "Luna" },
  { id: "Lupao", name: "Lupao" },
  { id: "Lupi", name: "Lupi" },
  { id: "Lupon", name: "Lupon" },
  { id: "Lutayan", name: "Lutayan" },
  { id: "Luuk (Omar)", name: "Luuk (Omar)" },
  { id: "MLang", name: "MLang" },
  { id: "Ma-ayon", name: "Ma-ayon" },
  { id: "Maasim", name: "Maasim" },
  { id: "Maasin", name: "Maasin" },
  { id: "Mabalacat", name: "Mabalacat" },
  { id: "Mabinay", name: "Mabinay" },
  { id: "Mabini", name: "Mabini" },
  { id: "Mabini (Doña Alicia)", name: "Mabini (Doña Alicia)" },
  { id: "Mabitac", name: "Mabitac" },
  { id: "Mabuhay", name: "Mabuhay" },
  { id: "Macabebe", name: "Macabebe" },
  { id: "Macalelon", name: "Macalelon" },
  { id: "MacArthur", name: "MacArthur" },
  { id: "Maco", name: "Maco" },
  { id: "Maconacon", name: "Maconacon" },
  { id: "Macrohon", name: "Macrohon" },
  { id: "Mactan Airport", name: "Mactan Airport" },
  { id: "Madalag", name: "Madalag" },
  { id: "Madalum", name: "Madalum" },
  { id: "Madamba", name: "Madamba" },
  { id: "Maddela", name: "Maddela" },
  { id: "Madrid", name: "Madrid" },
  { id: "Madridejos", name: "Madridejos" },
  { id: "Magalang", name: "Magalang" },
  { id: "Magallanes", name: "Magallanes" },
  { id: "Magarao", name: "Magarao" },
  { id: "Magdalena", name: "Magdalena" },
  { id: "Magdiwang", name: "Magdiwang" },
  { id: "Magpet", name: "Magpet" },
  { id: "Magsaysay", name: "Magsaysay" },
  { id: "Magsingal", name: "Magsingal" },
  { id: "Maguing", name: "Maguing" },
  { id: "Mahaplag", name: "Mahaplag" },
  { id: "Mahatao", name: "Mahatao" },
  { id: "Mahayag", name: "Mahayag" },
  { id: "Mahinog", name: "Mahinog" },
  { id: "Maigo", name: "Maigo" },
  { id: "Maimbung", name: "Maimbung" },
  { id: "Mainit", name: "Mainit" },
  { id: "Maitum", name: "Maitum" },
  { id: "Majayjay", name: "Majayjay" },
  { id: "Makati", name: "Makati" },
  { id: "Makato", name: "Makato" },
  { id: "Makilala", name: "Makilala" },
  { id: "Malabang", name: "Malabang" },
  { id: "Malabon", name: "Malabon" },
  { id: "Malabuyoc", name: "Malabuyoc" },
  { id: "Malalag", name: "Malalag" },
  { id: "Malangas", name: "Malangas" },
  { id: "Malapatan", name: "Malapatan" },
  { id: "Malasiqui", name: "Malasiqui" },
  { id: "Malay", name: "Malay" },
  { id: "Malaybalay", name: "Malaybalay" },
  { id: "Malibcong", name: "Malibcong" },
  { id: "Malilipot", name: "Malilipot" },
  { id: "Malimono", name: "Malimono" },
  { id: "Malinao", name: "Malinao" },
  { id: "Malita", name: "Malita" },
  { id: "Malitbog", name: "Malitbog" },
  { id: "Mallig", name: "Mallig" },
  { id: "Malolos", name: "Malolos" },
  { id: "Malungon", name: "Malungon" },
  { id: "Maluso", name: "Maluso" },
  { id: "Malvar", name: "Malvar" },
  { id: "Mamasapano", name: "Mamasapano" },
  { id: "Mambajao", name: "Mambajao" },
  { id: "Mamburao", name: "Mamburao" },
  { id: "Mambusao", name: "Mambusao" },
  { id: "Manabo", name: "Manabo" },
  { id: "Manaoag", name: "Manaoag" },
  { id: "Manapla", name: "Manapla" },
  { id: "Manay", name: "Manay" },
  { id: "Mandaluyong", name: "Mandaluyong" },
  { id: "Mandaue", name: "Mandaue" },
  { id: "Mangaldan", name: "Mangaldan" },
  { id: "Mangatarem", name: "Mangatarem" },
  { id: "Mangudadatu", name: "Mangudadatu" },
  { id: "Manila", name: "Manila" },
  { id: "Manito", name: "Manito" },
  { id: "Manjuyod", name: "Manjuyod" },
  { id: "Mankayan", name: "Mankayan" },
  { id: "Manolo Fortich", name: "Manolo Fortich" },
  { id: "Mansalay", name: "Mansalay" },
  { id: "Manticao", name: "Manticao" },
  { id: "Manukan", name: "Manukan" },
  { id: "Mapanas", name: "Mapanas" },
  { id: "Mapandan", name: "Mapandan" },
  { id: "Mapun (Cagayan de Sulu)", name: "Mapun (Cagayan de Sulu)" },
  { id: "Marabut", name: "Marabut" },
  { id: "Maragondon", name: "Maragondon" },
  { id: "Maragusan (San Mariano)", name: "Maragusan (San Mariano)" },
  { id: "Maramag", name: "Maramag" },
  { id: "Marantao", name: "Marantao" },
  { id: "Marawi & Kapatagan", name: "Marawi & Kapatagan" },
  { id: "Marcos", name: "Marcos" },
  { id: "Margosatubig", name: "Margosatubig" },
  { id: "Maria", name: "Maria" },
  { id: "Maria Aurora", name: "Maria Aurora" },
  { id: "Maribojoc", name: "Maribojoc" },
  { id: "Marihatag", name: "Marihatag" },
  { id: "Marikina", name: "Marikina" },
  { id: "Marilao", name: "Marilao" },
  { id: "Maripipi", name: "Maripipi" },
  { id: "Mariveles", name: "Mariveles" },
  { id: "Marogong", name: "Marogong" },
  { id: "Masantol", name: "Masantol" },
  { id: "Masbate City", name: "Masbate City" },
  { id: "Masinloc", name: "Masinloc" },
  { id: "Masiu", name: "Masiu" },
  { id: "Maslog", name: "Maslog" },
  { id: "Mataas na Kahoy", name: "Mataas na Kahoy" },
  { id: "Matag-ob", name: "Matag-ob" },
  { id: "Matalam", name: "Matalam" },
  { id: "Matalom", name: "Matalom" },
  { id: "Matanao", name: "Matanao" },
  { id: "Matanog", name: "Matanog" },
  { id: "Mati", name: "Mati" },
  { id: "Matnog", name: "Matnog" },
  { id: "Matuguinao", name: "Matuguinao" },
  { id: "Matungao", name: "Matungao" },
  { id: "Mauban", name: "Mauban" },
  { id: "Mawab", name: "Mawab" },
  { id: "Mayantoc", name: "Mayantoc" },
  { id: "Maydolong", name: "Maydolong" },
  { id: "Mayorga", name: "Mayorga" },
  { id: "Mayoyao (Mayaoyao)", name: "Mayoyao (Mayaoyao)" },
  { id: "Medellin", name: "Medellin" },
  { id: "Medina", name: "Medina" },
  { id: "Mendez (Mendez-Nuñez)", name: "Mendez (Mendez-Nuñez)" },
  { id: "Mercedes", name: "Mercedes" },
  { id: "Merida", name: "Merida" },
  { id: "Mexico", name: "Mexico" },
  { id: "Meycauayan", name: "Meycauayan" },
  { id: "Miagao", name: "Miagao" },
  { id: "Midsalip", name: "Midsalip" },
  { id: "Midsayap", name: "Midsayap" },
  { id: "Milagros", name: "Milagros" },
  { id: "Milaor", name: "Milaor" },
  { id: "Mina", name: "Mina" },
  { id: "Minalabac", name: "Minalabac" },
  { id: "Minalin", name: "Minalin" },
  { id: "Minglanilla", name: "Minglanilla" },
  { id: "Moalboal", name: "Moalboal" },
  { id: "Mobo", name: "Mobo" },
  { id: "Mogpog", name: "Mogpog" },
  { id: "Moises Padilla", name: "Moises Padilla" },
  { id: "Molave", name: "Molave" },
  { id: "Moncada", name: "Moncada" },
  { id: "Mondragon", name: "Mondragon" },
  { id: "Monkayo", name: "Monkayo" },
  { id: "Monreal", name: "Monreal" },
  { id: "Montevista", name: "Montevista" },
  { id: "Morong", name: "Morong" },
  { id: "Motiong", name: "Motiong" },
  { id: "Mulanay", name: "Mulanay" },
  { id: "Mulondo", name: "Mulondo" },
  { id: "Munai", name: "Munai" },
  { id: "Muntinlupa", name: "Muntinlupa" },
  { id: "Murcia", name: "Murcia" },
  { id: "Musuan", name: "Musuan" },
  { id: "Mutia", name: "Mutia" },
  { id: "Naawan", name: "Naawan" },
  { id: "Nabas", name: "Nabas" },
  { id: "Nabua", name: "Nabua" },
  { id: "Nabunturan", name: "Nabunturan" },
  { id: "Naga", name: "Naga" },
  { id: "Naga City", name: "Naga City" },
  { id: "Nagbukel", name: "Nagbukel" },
  { id: "Nagcarlan", name: "Nagcarlan" },
  { id: "Nagtipunan (Abbag)", name: "Nagtipunan (Abbag)" },
  { id: "Naguilian", name: "Naguilian" },
  { id: "Naguillan", name: "Naguillan" },
  { id: "Naic", name: "Naic" },
  { id: "Nampicuan", name: "Nampicuan" },
  { id: "Narra (Panacan)", name: "Narra (Panacan)" },
  { id: "Narvacan", name: "Narvacan" },
  { id: "Nasipit", name: "Nasipit" },
  { id: "Nasugbu", name: "Nasugbu" },
  { id: "Natividad", name: "Natividad" },
  { id: "Natonin", name: "Natonin" },
  { id: "Naujan", name: "Naujan" },
  { id: "Naval", name: "Naval" },
  { id: "Navotas", name: "Navotas" },
  { id: "New Bataan", name: "New Bataan" },
  { id: "New Corella", name: "New Corella" },
  { id: "New Lucena", name: "New Lucena" },
  { id: "New Washington", name: "New Washington" },
  { id: "Norala", name: "Norala" },
  { id: "Northern Kabuntalan", name: "Northern Kabuntalan" },
  { id: "Norzagaray", name: "Norzagaray" },
  { id: "Noveleta", name: "Noveleta" },
  { id: "Nueva Era", name: "Nueva Era" },
  { id: "Nueva Valencia", name: "Nueva Valencia" },
  { id: "Numancia", name: "Numancia" },
  { id: "Nunungan", name: "Nunungan" },
  { id: "Oas", name: "Oas" },
  { id: "Obando", name: "Obando" },
  { id: "Ocampo", name: "Ocampo" },
  { id: "Odiongan", name: "Odiongan" },
  { id: "Old Panamao", name: "Old Panamao" },
  { id: "Olongapo", name: "Olongapo" },
  { id: "Olutanga", name: "Olutanga" },
  { id: "Opol", name: "Opol" },
  { id: "Orani", name: "Orani" },
  { id: "Oras", name: "Oras" },
  { id: "Orion", name: "Orion" },
  { id: "Ormoc", name: "Ormoc" },
  { id: "Oroquieta", name: "Oroquieta" },
  { id: "Oslob", name: "Oslob" },
  { id: "Oton", name: "Oton" },
  { id: "Ozamiz", name: "Ozamiz" },
  { id: "Padada", name: "Padada" },
  { id: "Padre Burgos", name: "Padre Burgos" },
  { id: "Padre Garcia", name: "Padre Garcia" },
  { id: "Paete", name: "Paete" },
  { id: "Pagadian", name: "Pagadian" },
  { id: "Pagagawan", name: "Pagagawan" },
  { id: "Pagalungan", name: "Pagalungan" },
  { id: "Pagayawan", name: "Pagayawan" },
  { id: "Pagbilao", name: "Pagbilao" },
  { id: "Paglat", name: "Paglat" },
  { id: "Pagsanghan", name: "Pagsanghan" },
  { id: "Pagsanjan", name: "Pagsanjan" },
  { id: "Pagudpud", name: "Pagudpud" },
  { id: "Pakil", name: "Pakil" },
  { id: "Palanan", name: "Palanan" },
  { id: "Palanas", name: "Palanas" },
  { id: "Palapag", name: "Palapag" },
  {
    id: "Palauig & Scarborough Shoal",
    name: "Palauig & Scarborough Shoal",
  },
  { id: "Palayan", name: "Palayan" },
  { id: "Palimbang", name: "Palimbang" },
  { id: "Palo", name: "Palo" },
  { id: "Palompon", name: "Palompon" },
  { id: "Paluan", name: "Paluan" },
  { id: "Pambujan", name: "Pambujan" },
  { id: "Pamplona", name: "Pamplona" },
  { id: "Pan-ay", name: "Pan-ay" },
  { id: "Panabo", name: "Panabo" },
  { id: "Panaon", name: "Panaon" },
  { id: "Pandag", name: "Pandag" },
  { id: "Pandan", name: "Pandan" },
  { id: "Pandi", name: "Pandi" },
  { id: "Panganiban", name: "Panganiban" },
  { id: "Pangantucan", name: "Pangantucan" },
  { id: "Pangil", name: "Pangil" },
  { id: "Panglao", name: "Panglao" },
  {
    id: "Panglima Estino (New Panamao)",
    name: "Panglima Estino (New Panamao)",
  },
  {
    id: "Panglima Sugala (Balimbing)",
    name: "Panglima Sugala (Balimbing)",
  },
  { id: "Pangutaran", name: "Pangutaran" },
  { id: "Paniqui", name: "Paniqui" },
  { id: "Panitan", name: "Panitan" },
  { id: "Pantabangan", name: "Pantabangan" },
  { id: "Pantao Ragat", name: "Pantao Ragat" },
  { id: "Pantar", name: "Pantar" },
  { id: "Pantukan", name: "Pantukan" },
  { id: "Panukulan", name: "Panukulan" },
  { id: "Paoay", name: "Paoay" },
  { id: "Paombong", name: "Paombong" },
  { id: "Paracale", name: "Paracale" },
  { id: "Paracelis", name: "Paracelis" },
  { id: "Paraiso (Fabrica)", name: "Paraiso (Fabrica)" },
  { id: "Parañaque", name: "Parañaque" },
  { id: "Paranas (Wright)", name: "Paranas (Wright)" },
  { id: "Parang", name: "Parang" },
  { id: "Pasacao", name: "Pasacao" },
  { id: "Pasay", name: "Pasay" },
  { id: "Pasig", name: "Pasig" },
  { id: "Pasil", name: "Pasil" },
  { id: "Passi City", name: "Passi City" },
  { id: "Pastrana", name: "Pastrana" },
  { id: "Pasuquin", name: "Pasuquin" },
  { id: "Pata", name: "Pata" },
  { id: "Pateros", name: "Pateros" },
  { id: "Patikul", name: "Patikul" },
  { id: "Patnanungan", name: "Patnanungan" },
  { id: "Patnongon", name: "Patnongon" },
  { id: "Pavia", name: "Pavia" },
  { id: "Payao", name: "Payao" },
  { id: "Peñablanca", name: "Peñablanca" },
  { id: "Peñaranda", name: "Peñaranda" },
  { id: "Peñarrubia", name: "Peñarrubia" },
  { id: "Perez", name: "Perez" },
  {
    id: "Philippine Military Academy (Baguio City)",
    name: "Philippine Military Academy (Baguio City)",
  },
  { id: "Piagapo", name: "Piagapo" },
  { id: "Piat", name: "Piat" },
  { id: "Picong (Sultan Gumander)", name: "Picong (Sultan Gumander)" },
  { id: "Piddig", name: "Piddig" },
  { id: "Pidigan", name: "Pidigan" },
  { id: "Pigkawayan", name: "Pigkawayan" },
  { id: "Pikit", name: "Pikit" },
  { id: "Pila", name: "Pila" },
  { id: "Pilar", name: "Pilar" },
  { id: "Pili", name: "Pili" },
  { id: "Pililla", name: "Pililla" },
  { id: "Pinabacdao", name: "Pinabacdao" },
  { id: "Pinamalayan", name: "Pinamalayan" },
  { id: "Pinamungajan", name: "Pinamungajan" },
  { id: "Piñan", name: "Piñan" },
  { id: "Pinili", name: "Pinili" },
  { id: "Pintuyan", name: "Pintuyan" },
  { id: "Pinukpuk", name: "Pinukpuk" },
  { id: "Pio Duran (Malacbalac)", name: "Pio Duran (Malacbalac)" },
  { id: "Pio V. Corpuz", name: "Pio V. Corpuz" },
  { id: "Pitogo", name: "Pitogo" },
  { id: "Placer", name: "Placer" },
  { id: "Plaridel", name: "Plaridel" },
  { id: "Pola", name: "Pola" },
  { id: "Polanco", name: "Polanco" },
  { id: "Polangui", name: "Polangui" },
  { id: "Polillo", name: "Polillo" },
  { id: "Polomolok", name: "Polomolok" },
  { id: "Pontevedra", name: "Pontevedra" },
  { id: "Poona Bayabao", name: "Poona Bayabao" },
  { id: "Poona Piagapo", name: "Poona Piagapo" },
  { id: "Porac", name: "Porac" },
  { id: "Poro", name: "Poro" },
  { id: "Pototan", name: "Pototan" },
  { id: "Pozorrubio", name: "Pozorrubio" },
  {
    id: "Pres. Carlos P. Garcia (Pitogo)",
    name: "Pres. Carlos P. Garcia (Pitogo)",
  },
  { id: "Pres. Manuel A. Roxas", name: "Pres. Manuel A. Roxas" },
  { id: "Presentacion", name: "Presentacion" },
  { id: "President Quirino", name: "President Quirino" },
  { id: "President Roxas", name: "President Roxas" },
  { id: "Prieto Diaz", name: "Prieto Diaz" },
  { id: "Prosperidad", name: "Prosperidad" },
  {
    id: "Provincial Capitol, Lucena City",
    name: "Provincial Capitol, Lucena City",
  },
  { id: "Pualas", name: "Pualas" },
  { id: "Pudtol", name: "Pudtol" },
  { id: "Puerto Galera", name: "Puerto Galera" },
  { id: "Puerto Princesa", name: "Puerto Princesa" },
  { id: "Pugo", name: "Pugo" },
  { id: "Pulilan", name: "Pulilan" },
  { id: "Pulupandan", name: "Pulupandan" },
  { id: "Pura", name: "Pura" },
  { id: "Quezon", name: "Quezon" },
  { id: "Quezon City", name: "Quezon City" },
  { id: "Quinapondan", name: "Quinapondan" },
  { id: "Quirino", name: "Quirino" },
  { id: "Quirino (Angkaki)", name: "Quirino (Angkaki)" },
  { id: "Ragay", name: "Ragay" },
  { id: "Rajah Buayan", name: "Rajah Buayan" },
  { id: "Ramon", name: "Ramon" },
  { id: "Ramon Magsaysay (Liargo)", name: "Ramon Magsaysay (Liargo)" },
  { id: "Ramos", name: "Ramos" },
  { id: "Rapu-Rapu", name: "Rapu-Rapu" },
  { id: "Real", name: "Real" },
  {
    id: "Refugee Processing Center (Morong)",
    name: "Refugee Processing Center (Morong)",
  },
  { id: "Reina Mercedes", name: "Reina Mercedes" },
  { id: "Remedios T. Romualdez", name: "Remedios T. Romualdez" },
  { id: "Rizal", name: "Rizal" },
  { id: "Rizal (Liwan)", name: "Rizal (Liwan)" },
  { id: "Rodriguez, Montalban", name: "Rodriguez, Montalban" },
  { id: "Romblon", name: "Romblon" },
  { id: "Ronda", name: "Ronda" },
  { id: "Rosales", name: "Rosales" },
  { id: "Rosario", name: "Rosario" },
  { id: "Roseller T. Lim", name: "Roseller T. Lim" },
  { id: "Roxas", name: "Roxas" },
  { id: "Roxas City", name: "Roxas City" },
  { id: "Sabangan", name: "Sabangan" },
  { id: "Sablan", name: "Sablan" },
  { id: "Sablayan", name: "Sablayan" },
  { id: "Sabtang", name: "Sabtang" },
  { id: "Sadanga", name: "Sadanga" },
  { id: "Sagada", name: "Sagada" },
  { id: "Sagay", name: "Sagay" },
  { id: "Sagay City", name: "Sagay City" },
  { id: "Sagbayan", name: "Sagbayan" },
  { id: "Sagñay", name: "Sagñay" },
  { id: "Saguday", name: "Saguday" },
  { id: "Saguiaran", name: "Saguiaran" },
  { id: "Saint Bernard", name: "Saint Bernard" },
  { id: "Salay", name: "Salay" },
  { id: "Salcedo", name: "Salcedo" },
  { id: "Salcedo (Baugen)", name: "Salcedo (Baugen)" },
  { id: "Sallapadan", name: "Sallapadan" },
  { id: "Salug", name: "Salug" },
  { id: "Salvador", name: "Salvador" },
  { id: "Salvador Benedicto", name: "Salvador Benedicto" },
  { id: "Samal", name: "Samal" },
  { id: "Samal City", name: "Samal City" },
  { id: "Samboan", name: "Samboan" },
  { id: "Sampaloc", name: "Sampaloc" },
  { id: "San Agustin", name: "San Agustin" },
  { id: "San Andres", name: "San Andres" },
  { id: "San Antonio", name: "San Antonio" },
  { id: "San Benito", name: "San Benito" },
  { id: "San Carlos City", name: "San Carlos City" },
  { id: "San Clemente", name: "San Clemente" },
  { id: "San Dionisio", name: "San Dionisio" },
  { id: "San Emilio", name: "San Emilio" },
  { id: "San Enrique", name: "San Enrique" },
  { id: "San Esteban", name: "San Esteban" },
  { id: "San Fabian", name: "San Fabian" },
  { id: "San Felipe", name: "San Felipe" },
  { id: "San Fernando", name: "San Fernando" },
  { id: "San Fernando City", name: "San Fernando City" },
  { id: "San Francisco", name: "San Francisco" },
  { id: "San Francisco (Aurora)", name: "San Francisco (Aurora)" },
  { id: "San Gabriel", name: "San Gabriel" },
  { id: "San Guillermo", name: "San Guillermo" },
  { id: "San Ildefonso", name: "San Ildefonso" },
  { id: "San Isidro", name: "San Isidro" },
  { id: "San Jacinto", name: "San Jacinto" },
  { id: "San Joaquin", name: "San Joaquin" },
  { id: "San Jorge", name: "San Jorge" },
  { id: "San Jose", name: "San Jose" },
  { id: "San Jose City", name: "San Jose City" },
  { id: "San Jose De Buan", name: "San Jose De Buan" },
  { id: "San Jose del Monte", name: "San Jose del Monte" },
  { id: "San Juan", name: "San Juan" },
  { id: "San Juan (Cabalian)", name: "San Juan (Cabalian)" },
  { id: "San Juan (Lapog)", name: "San Juan (Lapog)" },
  { id: "San Julian", name: "San Julian" },
  { id: "San Leonardo", name: "San Leonardo" },
  { id: "San Lorenzo", name: "San Lorenzo" },
  { id: "San Lorenzo Ruiz", name: "San Lorenzo Ruiz" },
  { id: "San Luis", name: "San Luis" },
  { id: "San Manuel", name: "San Manuel" },
  { id: "San Manuel (Callang)", name: "San Manuel (Callang)" },
  { id: "San Marcelino", name: "San Marcelino" },
  { id: "San Mariano", name: "San Mariano" },
  { id: "San Mateo", name: "San Mateo" },
  { id: "San Miguel", name: "San Miguel" },
  { id: "San Miguel, Tarlac City", name: "San Miguel, Tarlac City" },
  { id: "San Narciso", name: "San Narciso" },
  { id: "San Nicolas", name: "San Nicolas" },
  { id: "San Pablo", name: "San Pablo" },
  { id: "San Pablo City", name: "San Pablo City" },
  { id: "San Pascual", name: "San Pascual" },
  { id: "San Pedro City", name: "San Pedro City" },
  { id: "San Policarpo", name: "San Policarpo" },
  { id: "San Quintin", name: "San Quintin" },
  { id: "San Rafael", name: "San Rafael" },
  { id: "San Remigio", name: "San Remigio" },
  { id: "San Ricardo", name: "San Ricardo" },
  { id: "San Roque", name: "San Roque" },
  { id: "San Sebastian", name: "San Sebastian" },
  { id: "San Simon", name: "San Simon" },
  { id: "San Teodoro", name: "San Teodoro" },
  { id: "San Vicente", name: "San Vicente" },
  { id: "Sanchez-Mira", name: "Sanchez-Mira" },
  {
    id: "Sangley Point Naval Base (Cavite City)",
    name: "Sangley Point Naval Base (Cavite City)",
  },
  { id: "Santa", name: "Santa" },
  { id: "Santa Ana", name: "Santa Ana" },
  { id: "Santa Barbara", name: "Santa Barbara" },
  { id: "Santa Catalina", name: "Santa Catalina" },
  { id: "Santa Cruz", name: "Santa Cruz" },
  { id: "Santa Elena", name: "Santa Elena" },
  { id: "Santa Fe", name: "Santa Fe" },
  { id: "Santa Fe (Imugan)", name: "Santa Fe (Imugan)" },
  { id: "Santa Ignacia", name: "Santa Ignacia" },
  { id: "Santa Josefa", name: "Santa Josefa" },
  { id: "Santa Lucia", name: "Santa Lucia" },
  { id: "Santa Magdalena", name: "Santa Magdalena" },
  { id: "Santa Marcela", name: "Santa Marcela" },
  { id: "Santa Margarita", name: "Santa Margarita" },
  { id: "Santa Maria", name: "Santa Maria" },
  { id: "Santa Maria (Imelda)", name: "Santa Maria (Imelda)" },
  { id: "Santa Monica", name: "Santa Monica" },
  { id: "Santa Praxedes", name: "Santa Praxedes" },
  { id: "Santa Rita", name: "Santa Rita" },
  { id: "Santa Rosa", name: "Santa Rosa" },
  { id: "Santa Rosa City", name: "Santa Rosa City" },
  { id: "Santa Teresita", name: "Santa Teresita" },
  { id: "Santander", name: "Santander" },
  { id: "Santiago", name: "Santiago" },
  { id: "Santiago City", name: "Santiago City" },
  { id: "Santo Domingo", name: "Santo Domingo" },
  { id: "Santo Niño", name: "Santo Niño" },
  { id: "Santo Tomas", name: "Santo Tomas" },
  { id: "Santol", name: "Santol" },
  { id: "Sapa-Sapa", name: "Sapa-Sapa" },
  { id: "Sapad", name: "Sapad" },
  { id: "Sapang Dalaga", name: "Sapang Dalaga" },
  { id: "Sapian", name: "Sapian" },
  { id: "Sara", name: "Sara" },
  { id: "Sarangani", name: "Sarangani" },
  { id: "Sariaya", name: "Sariaya" },
  { id: "Sarrat", name: "Sarrat" },
  { id: "Sasmuan", name: "Sasmuan" },
  { id: "Science City of Muñoz", name: "Science City of Muñoz" },
  { id: "Sebaste", name: "Sebaste" },
  { id: "Senator Ninoy Aquino", name: "Senator Ninoy Aquino" },
  { id: "Sergio Osmeña Sr.", name: "Sergio Osmeña Sr." },
  { id: "Sevilla", name: "Sevilla" },
  { id: "Shariff Aguak", name: "Shariff Aguak" },
  { id: "Shariff Aguak (Maganoy)", name: "Shariff Aguak (Maganoy)" },
  { id: "Shariff Saydona Mustapha", name: "Shariff Saydona Mustapha" },
  { id: "Siasi", name: "Siasi" },
  { id: "Siaton", name: "Siaton" },
  { id: "Siay", name: "Siay" },
  { id: "Siayan", name: "Siayan" },
  { id: "Sibagat", name: "Sibagat" },
  { id: "Sibalom", name: "Sibalom" },
  { id: "Sibonga", name: "Sibonga" },
  { id: "Sibuco", name: "Sibuco" },
  { id: "Sibulan", name: "Sibulan" },
  { id: "Sibunag", name: "Sibunag" },
  { id: "Sibutad", name: "Sibutad" },
  { id: "Sibutu", name: "Sibutu" },
  { id: "Sierra Bullones", name: "Sierra Bullones" },
  { id: "Sigay", name: "Sigay" },
  { id: "Sigma", name: "Sigma" },
  { id: "Sikatuna", name: "Sikatuna" },
  { id: "Silago", name: "Silago" },
  { id: "Silang", name: "Silang" },
  { id: "Silay", name: "Silay" },
  { id: "Silvino Lobos", name: "Silvino Lobos" },
  { id: "Simunul", name: "Simunul" },
  { id: "Sinacaban", name: "Sinacaban" },
  { id: "Sinait", name: "Sinait" },
  { id: "Sindangan", name: "Sindangan" },
  { id: "Siniloan", name: "Siniloan" },
  { id: "Siocon", name: "Siocon" },
  { id: "Sipalay", name: "Sipalay" },
  { id: "Sipocot", name: "Sipocot" },
  { id: "Siquijor", name: "Siquijor" },
  { id: "Sirawai", name: "Sirawai" },
  { id: "Siruma", name: "Siruma" },
  { id: "Sison", name: "Sison" },
  { id: "Sitangkai", name: "Sitangkai" },
  { id: "Socorro", name: "Socorro" },
  { id: "Sogod", name: "Sogod" },
  { id: "Solana", name: "Solana" },
  { id: "Solano", name: "Solano" },
  { id: "Solsona", name: "Solsona" },
  {
    id: "Sominot (Don Mariano Marcos)",
    name: "Sominot (Don Mariano Marcos)",
  },
  { id: "Sorsogon City", name: "Sorsogon City" },
  { id: "South Ubian", name: "South Ubian" },
  { id: "South Upi", name: "South Upi" },
  { id: "Sual", name: "Sual" },
  { id: "Subic", name: "Subic" },
  {
    id: "Subic Bay Freeport Zone (Metro Subic)",
    name: "Subic Bay Freeport Zone (Metro Subic)",
  },
  { id: "Sudipen", name: "Sudipen" },
  { id: "Sugbongcogon", name: "Sugbongcogon" },
  { id: "Sugpon", name: "Sugpon" },
  { id: "Sulat", name: "Sulat" },
  { id: "Sulop", name: "Sulop" },
  { id: "Sultan Kudarat", name: "Sultan Kudarat" },
  { id: "Sultan Mastura", name: "Sultan Mastura" },
  {
    id: "Sultan Naga Dimaporo (Karomatan)",
    name: "Sultan Naga Dimaporo (Karomatan)",
  },
  { id: "Sultan sa Barongis", name: "Sultan sa Barongis" },
  { id: "Sultan Sumagka (Talitay)", name: "Sultan Sumagka (Talitay)" },
  { id: "Sumilao", name: "Sumilao" },
  { id: "Sumisip", name: "Sumisip" },
  { id: "Surallah", name: "Surallah" },
  { id: "Surigao City", name: "Surigao City" },
  { id: "Suyo", name: "Suyo" },
  { id: "TBoli", name: "TBoli" },
  { id: "Taal", name: "Taal" },
  { id: "Tabaco", name: "Tabaco" },
  { id: "Tabango", name: "Tabango" },
  { id: "Tabina", name: "Tabina" },
  { id: "Tabogon", name: "Tabogon" },
  { id: "Tabontabon", name: "Tabontabon" },
  { id: "Tabuelan", name: "Tabuelan" },
  { id: "Tabuk City", name: "Tabuk City" },
  { id: "Tacloban", name: "Tacloban" },
  { id: "Tacurong", name: "Tacurong" },
  { id: "Tadian", name: "Tadian" },
  { id: "Taft", name: "Taft" },
  { id: "Tagana-an", name: "Tagana-an" },
  { id: "Tagapul-an", name: "Tagapul-an" },
  { id: "Tagaytay City", name: "Tagaytay City" },
  { id: "Tagbilaran", name: "Tagbilaran" },
  { id: "Tagbina", name: "Tagbina" },
  { id: "Tagkawayan", name: "Tagkawayan" },
  { id: "Tago", name: "Tago" },
  { id: "Tagoloan", name: "Tagoloan" },
  { id: "Tagoloan II", name: "Tagoloan II" },
  { id: "Tagudin", name: "Tagudin" },
  { id: "Taguig", name: "Taguig" },
  { id: "Tagum", name: "Tagum" },
  { id: "Talacogon", name: "Talacogon" },
  { id: "Talakag", name: "Talakag" },
  { id: "Talalora", name: "Talalora" },
  { id: "Talavera", name: "Talavera" },
  { id: "Talayan", name: "Talayan" },
  { id: "Talibon", name: "Talibon" },
  { id: "Talipao", name: "Talipao" },
  { id: "Talisay", name: "Talisay" },
  { id: "Talisay City", name: "Talisay City" },
  { id: "Talisayan", name: "Talisayan" },
  { id: "Talugtug", name: "Talugtug" },
  { id: "Talusan", name: "Talusan" },
  { id: "Tambulig", name: "Tambulig" },
  { id: "Tampakan", name: "Tampakan" },
  { id: "Tamparan", name: "Tamparan" },
  { id: "Tampilisan", name: "Tampilisan" },
  { id: "Tanauan", name: "Tanauan" },
  { id: "Tanauan City", name: "Tanauan City" },
  { id: "Tanay", name: "Tanay" },
  { id: "Tandag", name: "Tandag" },
  { id: "Tandubas", name: "Tandubas" },
  { id: "Tangalan", name: "Tangalan" },
  { id: "Tangcal", name: "Tangcal" },
  { id: "Tangub", name: "Tangub" },
  { id: "Tanjay", name: "Tanjay" },
  { id: "Tantangan", name: "Tantangan" },
  { id: "Tanudan", name: "Tanudan" },
  { id: "Tanza", name: "Tanza" },
  { id: "Tapaz", name: "Tapaz" },
  { id: "Tapul", name: "Tapul" },
  { id: "Taraka", name: "Taraka" },
  { id: "Tarangnan", name: "Tarangnan" },
  { id: "Tarlac City", name: "Tarlac City" },
  { id: "Tarragona", name: "Tarragona" },
  { id: "Tayabas", name: "Tayabas" },
  { id: "Tayasan", name: "Tayasan" },
  { id: "Taysan", name: "Taysan" },
  { id: "Taytay", name: "Taytay" },
  { id: "Tayug", name: "Tayug" },
  { id: "Tayum", name: "Tayum" },
  { id: "Teresa", name: "Teresa" },
  { id: "Ternate", name: "Ternate" },
  { id: "Tiaong", name: "Tiaong" },
  { id: "Tibiao", name: "Tibiao" },
  { id: "Tigaon", name: "Tigaon" },
  { id: "Tigbao", name: "Tigbao" },
  { id: "Tigbauan", name: "Tigbauan" },
  { id: "Tilik", name: "Tilik" },
  { id: "Tinambac", name: "Tinambac" },
  { id: "Tinegh", name: "Tinegh" },
  { id: "Tinglayan", name: "Tinglayan" },
  { id: "Tingloy", name: "Tingloy" },
  { id: "Tinoc", name: "Tinoc" },
  { id: "Tipo-Tipo", name: "Tipo-Tipo" },
  { id: "Titay", name: "Titay" },
  { id: "Tiwi", name: "Tiwi" },
  { id: "Tobias Fornier (Dao)", name: "Tobias Fornier (Dao)" },
  { id: "Toboso", name: "Toboso" },
  { id: "Toledo", name: "Toledo" },
  { id: "Tolosa", name: "Tolosa" },
  { id: "Tomas Oppus", name: "Tomas Oppus" },
  { id: "Torrijos", name: "Torrijos" },
  { id: "Trece Martires City", name: "Trece Martires City" },
  { id: "Trento", name: "Trento" },
  { id: "Trinidad", name: "Trinidad" },
  { id: "Tuao", name: "Tuao" },
  { id: "Tuba", name: "Tuba" },
  { id: "Tubajon", name: "Tubajon" },
  { id: "Tubao", name: "Tubao" },
  { id: "Tubaran", name: "Tubaran" },
  { id: "Tubay", name: "Tubay" },
  { id: "Tubigon", name: "Tubigon" },
  { id: "Tublay", name: "Tublay" },
  { id: "Tubo", name: "Tubo" },
  { id: "Tubod", name: "Tubod" },
  { id: "Tubungan", name: "Tubungan" },
  { id: "Tuburan", name: "Tuburan" },
  { id: "Tudela", name: "Tudela" },
  { id: "Tugaya", name: "Tugaya" },
  { id: "Tuguegarao", name: "Tuguegarao" },
  { id: "Tukuran", name: "Tukuran" },
  { id: "Tulay-na-Lupa", name: "Tulay-na-Lupa" },
  { id: "Tulunan", name: "Tulunan" },
  { id: "Tumauini", name: "Tumauini" },
  { id: "Tunga", name: "Tunga" },
  { id: "Tungawan", name: "Tungawan" },
  { id: "Tupi", name: "Tupi" },
  { id: "Turtle Islands (Taganak)", name: "Turtle Islands (Taganak)" },
  { id: "Tuy", name: "Tuy" },
  { id: "Ubay", name: "Ubay" },
  { id: "Umingan", name: "Umingan" },
  { id: "Unisan", name: "Unisan" },
  {
    id: "University of the Philippines, Los Baños",
    name: "University of the Philippines, Los Baños",
  },
  { id: "Upi", name: "Upi" },
  { id: "Urbiztondo", name: "Urbiztondo" },
  { id: "Urdaneta City", name: "Urdaneta City" },
  { id: "Uson", name: "Uson" },
  { id: "Uyugan", name: "Uyugan" },
  { id: "Valderrama", name: "Valderrama" },
  { id: "Valencia", name: "Valencia" },
  { id: "Valencia City", name: "Valencia City" },
  { id: "Valenzuela", name: "Valenzuela" },
  { id: "Valladolid", name: "Valladolid" },
  { id: "Vallehermoso", name: "Vallehermoso" },
  { id: "Veruela", name: "Veruela" },
  { id: "Victoria", name: "Victoria" },
  { id: "Victorias", name: "Victorias" },
  { id: "Viga", name: "Viga" },
  { id: "Vigan", name: "Vigan" },
  { id: "Villa Verde (Ibung)", name: "Villa Verde (Ibung)" },
  { id: "Villaba", name: "Villaba" },
  { id: "Villanueva", name: "Villanueva" },
  { id: "Villareal", name: "Villareal" },
  { id: "Villasis", name: "Villasis" },
  { id: "Villaviciosa", name: "Villaviciosa" },
  { id: "Vincenzo A. Sagun", name: "Vincenzo A. Sagun" },
  { id: "Vintar", name: "Vintar" },
  { id: "Vinzons", name: "Vinzons" },
  { id: "Virac", name: "Virac" },
  { id: "Wao", name: "Wao" },
  { id: "Zamboanga City", name: "Zamboanga City" },
  { id: "Zamboanguita", name: "Zamboanguita" },
  { id: "Zaragoza", name: "Zaragoza" },
  { id: "Zarraga", name: "Zarraga" },
  { id: "Zumarraga", name: "Zumarraga" },
];

// const UrlFieldNmae = () => {
//   const record = useRecordContext();
//   return (
//     <a href=`${record.shipping_governament_url}`>
//   )
// }

const UrlFieldNmae1 = () => {
  const record = useRecordContext();
  console.log("record.name", record);
  return (
    record && (
      <a href={record?.shipping_governament_url} target="_blank">
        {record?.shipping_governament_url ? "View Imgae/File" : "-"}
      </a>
    )
  );
};

const UrlFieldNmae2 = () => {
  const record = useRecordContext();
  console.log("record.name", record);
  return (
    record && (
      <a href={record?.shipping_bir_url} target="_blank">
        {record?.shipping_bir_url ? "View Imgae/File" : "-"}
      </a>
    )
  );
};

const UrlFieldNmae3 = () => {
  const record = useRecordContext();
  console.log("record.name", record);
  return (
    record && (
      <a href={record?.self_photo_url} target="_blank">
        {record?.self_photo_url ? "View Imgae/File" : "-"}
      </a>
    )
  );
};

const customerTypes = [
  { id: "Individual Home Owner/DIY", name: "Individual Home Owner/DIY" },
  { id: "Freelance Builder/Designer", name: "Freelance Builder/Designer" },
  { id: "Retail/Hardare Store", name: "Retail/Hardare Store" },
  {
    id: "Contractor/Construction Services",
    name: "Contractor/Construction Services",
  },
  { id: "Design Firm", name: "Design Firm" },
  { id: "Real Estate Developer", name: "Real Estate Developer" },
  {
    id: "Private Company (Non-construction)",
    name: "Private Company (Non-construction)",
  },
];

const Filters = (props) => (
  <Filter {...props}>
    <TextInput source="customer_first_name" label="Customer First Name" />
    <TextInput source="customer_middle_name" label="Customer Middle Name" />
    <TextInput source="customer_last_name" label="Customer Last Name" />
    <TextInput source="customer_mobile" label="Customer Mobile Number" />
    <TextInput source="customer_email" label="Customer Email Address" />

    <TextInput source="business_name" label="Business Name" />
    <AutocompleteInput
      source="business_region"
      choices={regions}
      label="Business Province/Region"
    />
    <AutocompleteInput
      source="business_city"
      choices={cities}
      label="Business City/Municipality"
    />
    <TextInput
      source="business_house_no_n_building"
      label="Business House No./Unit No. & Building"
    />
    <TextInput source="business_street" label="Business Street" />
    <TextInput source="business_barangay" label="Business Barangay" />
    <TextInput source="business_zip_code" label="Business ZIP Code" />
    <TextInput source="business_tin_no" label="Business TIN No." />
    <TextInput source="business_customer_type" />
    <AutocompleteInput
      source="business_customer_type"
      choices={customerTypes}
      label="Business Customer Type"
    />
    <TextInput
      source="business_owner_first_name"
      label="Business Owner First Name"
    />
    <TextInput
      source="business_middle_name"
      label="Business Owner Middle Name"
    />
    <TextInput
      source="business_owner_last_name"
      label="Business Owner Last Name"
    />
    <TextInput source="business_email" label="Business E-mail" />
    <TextInput source="business_phone" label="Business Phone/Mobile" />

    <TextInput source="shipping_name" label="Shipping Information" />
    <AutocompleteInput
      source="shipping_region"
      choices={regions}
      label="Shipping Province/Region"
    />
    <AutocompleteInput
      source="shipping_city"
      choices={cities}
      label="Shipping City/Municipality"
    />
    <TextInput
      source="shipping_house_no_n_building"
      label="Shipping house number"
    />

    <TextInput source="shipping_street" label="Shipping Street" />
    <TextInput source="shipping_barangay" label="Shipping Barangay" />
    <TextInput source="shipping_zip_code" label="Shipping ZIP Code" />
    <TextInput
      source="shipping_contact_person"
      label="Shipping Contact Person"
    />
    <TextInput
      source="shipping_contact_number"
      label="Shipping Contact Number (Mobile)"
    />

    <DateTimeInput
      source="created_at_from_date"
      label="Created From Date"
      showTime
    />
    <DateTimeInput
      source="created_at_to_date"
      label="Created To Date"
      showTime
    />

    <TextInput source="referred_by" label="Referred By" />

  </Filter>
);

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    // 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D'
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    } else {
      setCustomFilterUrl(
        location.search
        // 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D'
      );
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    }
  };

  const onClose = () => {
    // this.setState({ modalShow: false });
    setModalShow(false);
  };
  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const RegisteredUsersList = (props) => (
  <Scrollbars className="scroll-container">
    <List
      title="Registered Users"
      {...props}
      filters={<Filters />}
      actions={<ListActions permissions={props} />}
      sort={{ field: "created_at", order: "DESC" }}
    >
      <Datagrid bulkActionButtons={false}>
        <TextField source="customer_first_name" label="Customer First Name" />
        <TextField source="customer_middle_name" label="Customer Middle Name" />
        <TextField source="customer_last_name" label="Customer Last Name" />
        <TextField source="customer_mobile" label="Customer Mobile Number" />
        <TextField source="customer_email" label="Customer Email Address" />

        <TextField source="business_name" label="Business Name" />
        <TextField source="business_region" label="Business Province/Region" />
        <TextField source="business_city" label="Business City/Municipality" />
        <TextField
          source="business_house_no_n_building"
          label="Business House No./Unit No. & Building"
        />
        <TextField source="business_street" label="Business Street" />
        <TextField source="business_barangay" label="Business Barangay" />
        <TextField source="business_zip_code" label="Business ZIP Code" />
        <TextField source="business_tin_no" label="Business TIN No." />
        <TextField
          source="business_customer_type"
          label="Business Customer Type"
        />
        <TextField
          source="business_owner_first_name"
          label="Business Owner First Name"
        />
        <TextField
          source="business_middle_name"
          label="Business Owner Middle Name"
        />
        <TextField
          source="business_owner_last_name"
          label="Business Owner Last Name"
        />
        <TextField source="business_email" label="Business E-mail" />
        <TextField source="business_phone" label="Business Phone/Mobile" />

        <TextField source="shipping_name" label="Shipping Information" />
        <TextField source="shipping_region" label="Shipping Province/Region" />
        <TextField source="shipping_city" label="Shipping City/Municipality" />
        <TextField
          source="shipping_house_no_n_building"
          label="Shipping House No./Unit No. & Building"
        />
        <TextField source="shipping_street" label="Shipping Street" />
        <TextField source="shipping_barangay" label="Shipping Barangay" />
        <TextField source="shipping_zip_code" label="Shipping ZIP Code" />
        <TextField
          source="shipping_contact_person"
          label="Shipping Contact Person"
        />
        <TextField
          source="shipping_contact_number"
          label="Shipping Contact Number (Mobile)"
        />

        <DateField label="Created Date" source="created_at" showTime />

        <UrlFieldNmae1
          source="shipping_governament_url"
          target="_blank"
          label="Supporting Document Government ID"
        />
        <UrlFieldNmae2
          source="shipping_bir_url"
          target="_blank"
          label="Supporting Document BIR2303"
        />
        <UrlFieldNmae3
          source="self_photo_url"
          target="_blank"
          label="Supporting Document Self Photo"
        />
        <TextField source="referred_by" label="Referred By" />
      </Datagrid>
    </List>
  </Scrollbars>
);

export default RegisteredUsersList;
